import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilsService } from '../../services/utils.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../../../../src/environments/environment.dev';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { LimitNumberDirective } from '../../directives/limit-number.directive';
import { SafehtmlPipe } from '../../pipes/safehtml.pipe';

@Component({
  selector: 'app-inputforms',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatCheckboxModule, LimitNumberDirective, SafehtmlPipe],
  templateUrl: './inputforms.component.html',
  styleUrl: './inputforms.component.scss'
})
export class InputformsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() formName: any;
  @Input() formFieldsData: any;
  @Input() btnName: any;
  @Input() updateCount: any;
  @Output() fetchCity = new EventEmitter<{}>();
  @Output() formSubmit = new EventEmitter<string>();
  sub: Subscription = new Subscription()
  customForm: any;
  formFields:any = [];
  formFieldDataArr: any[] =[];
  focusedControl: any;
  formChange: any;

  environment: any = environment;

  constructor(public utils: UtilsService, public fb: FormBuilder, private jsonDataService: JsonDataService) {
    this.getJsonData(); }

  ngOnInit() {
    if (!this.formName) {
      console.error('Input `formName` is undefined in InputformsComponent.');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    let chg: any;
    chg = changes;
    if (chg.updateCount && chg.updateCount.previousValue && (chg.updateCount.currentValue != chg.updateCount.previousValue)) {
      this.initiateFormCreation();
    }
  }

  initiateFormCreation(): void {

    this.formFields = [];
    this.btnName = '';
    if (this.formFieldsData && this.formFieldsData.formFields && this.formFieldsData.formFields.length) {
        this.formFields = this.formFieldsData.formFields;
        this.btnName = this.formFieldsData.btnName;
    } else {

        const fieldData = this.formFieldDataArr.filter((x: any) => {
            return x.name?.toLowerCase() === this.formName?.toLowerCase();
        });

        if (fieldData.length > 0 && fieldData[0].formFields && fieldData[0].btnName) {
            this.formFields = fieldData[0].formFields;
            this.btnName = fieldData[0].btnName;
        } else {
            console.error('Form data not found for formName:', this.formName);
        }
    }

    this.customForm = '';
    this.createFormControls(this.formFields);
}



  getJsonData() {
    this.sub.add(this.jsonDataService.getFormFieldsMockJsonData().subscribe({
      next: (res: any) => {
        this.formFieldDataArr = res;
        setTimeout(() => {
        this.initiateFormCreation();
          
        },100);
      },
      error: (err: any) => {
      }
    }));
  }
  createFormControls(formFields: any) {

    if (this.customForm && this.customForm.status) { this.customForm.reset(); }
    const form: any = {}
    formFields.forEach((element: any) => {
      form[this.utils.getFormControlName(element.label)] = new FormControl(element.value ? element.value : '', this.setValidatorArray(element));
    });

    if (this.formName.toLowerCase() == 'resetpassword' || this.formName.toLowerCase() == 'changepassword')
      this.customForm = this.fb.group(form,
        { validators: this.ConfirmPasswordValidator('new_password', 'confirm_password') }
      );
    else {
      this.customForm = new FormGroup(form);

    }
    if (this.customForm && !this.btnName) {
      this.sub.add(    this.formChange = this.customForm.valueChanges.subscribe((_value: any) => {
        this.formSubmit.emit(this.customForm);
        if (this.formName == 'shippingAddress') {
          this.markFormGroupTouched(this.customForm)
        }
      }))
      this.formSubmit.emit(this.customForm);
    }
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  preventNonNumericInput(event: KeyboardEvent): void {
    const key = event.key;
    if (!/^\d$/.test(key) && key !== 'Backspace' && key !== 'Tab') {
      event.preventDefault();
    }
  }
  

  setValidatorArray(element: any) {
    let arr = [];
    if (element.required) { arr.push(Validators.required) }
    if (element.maxLength) { arr.push(Validators.maxLength(element.maxLength)); }
    if (element.minLength) { arr.push(Validators.minLength(element.minLength)); }
    if (element.for == 'noSpace') { arr.push(Validators.pattern(this.utils.noSpaceRegex)); }
    if (element.for == 'name') { arr.push(Validators.pattern(this.utils.nameRegex)); }
    if (element.type == 'email') { arr.push(Validators.pattern(this.utils.emailRegex)); }
    if (element.type == 'password') { arr.push(Validators.pattern(this.utils.passwordRegex)); }
    if (element.for == 'address') { arr.push(Validators.pattern(this.utils.addressRegex)); }
    return arr;
  }

  get f() {
    return this.customForm.controls;
  }

  checkValidation(label: any) {
    let controlName = this.utils.getFormControlName(label);
    return (this.f[controlName].errors && this.f[controlName].touched);
  }

  checkValidationMessage(data: any) {
    let label = data.label;
    let controlName = this.utils.getFormControlName(label);
    if (this.f[controlName].errors) {
      if (this.f[controlName].errors['required']) {
        return label + ' is required';
      }
      if (this.f[controlName].errors.minlength) {
        return label + ' minimum allowed length should be: ' + this.f[controlName].errors.minlength.requiredLength;
      }
      else if (this.f[controlName].errors.maxlength) {
        return label + ' maximum allowed length is: ' + this.f[controlName].errors.maxlength.requiredLength;
      }
      else if (data.for && data.for.toLowerCase() == 'nospace' && this.f[controlName].errors.pattern) {
        return label + ' is not valid, remove unwanted spaces (if any).';
      }
      else if (data.type.toLowerCase() == 'email' && this.f[controlName].errors.pattern) {
        return label + ' is not valid.';
      }
      else if (data.for && data.for.toLowerCase() == 'name' && this.f[controlName].errors.pattern) {
        return label + ' is not valid. Only alphabetic input is allowed. remove unwanted spaces (if any).';
      }
      else if (this.f[controlName].errors.pattern && data.for == 'address') {
        return label + " is not valid. Only alphabet, number, special characters(- _ , ' /) and spaces are allowed. At first place only number or alphabet is allowed remove space (if any).";
      }
      else if (
        (data.type == 'password' && this.f[controlName].errors.pattern) && !((controlName == 'new_password' && this.f['new_password'].errors.ConfirmValidator) || (controlName == 'confirm_password' && this.f['confirm_password'].errors.ConfirmValidator))) {
        return label + ' is not valid, must contain At least one upper case, number and special character';
      }
      else if ((controlName == 'new_password' && (this.f['new_password'].errors.ConfirmValidator == true)) || (controlName == 'confirm_password' && (this.f['confirm_password'].errors.ConfirmValidator == true))) {
        return 'Password and Confirm Password didn' + 't match.';
      }
      else
        return '';
      }
    else
      return '';
    }

  onFocus(label: any, flag: boolean) {
    let control = this.utils.getFormControlName(label);
    flag ? this.focusedControl = control : this.focusedControl = '';
  }

  ConfirmPasswordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      let control = formGroup.controls[controlName];
      let matchingControl = formGroup.controls[matchingControlName]
      if (matchingControl.errors && !matchingControl.errors['ConfirmValidator']) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ ConfirmValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  valueUpdateOfCheckBox(label: any, event: any, required: any) {
    const control = this.utils.getFormControlName(label);
    if (required) {
      if (event.target && event.target.checked) {
        this.f[control].setErrors(null);
      }
      else {
        this.f[control].setErrors({ required: true });
      }
    }
  }

  valueChangeHandler(_event: any, label: any) {
    if (this.utils.getFormControlName(label) == 'pin_code') {
      if (this.f['pin_code'] && this.f['pin_code'].status) {
        let selectedValue = this.f['pin_code'].value;
        if (this.utils.pinCodeLength == String(selectedValue).length) {
          this.fetchCity.emit(this.customForm.value);
        }
        else {
          this.f['state'].setValue('');
          if (this.f['country'])
            this.f['country'].setValue('');
        }
      }
    }
  }

  haveValue(label: any) {
    let control = this.utils.getFormControlName(label);
    return this.f[control].value ? true : false;
  }
  submitForm() {
    this.formSubmit.emit(this.customForm)
  }

  ngOnDestroy(): void {
    if (this.formChange) { this.formChange.unsubscribe(); }
    this.sub.unsubscribe()
  }

}
